import {Show} from 'platform/foundation';

import {useGetCurrentUserInfoQuery} from '@dms/api/customer';
import {UserAbsenceGrid} from '@dms/features/user-absence';
import i18n from '@dms/i18n';

import {MyProfileTemplate} from '../../components/MyProfileTemplate/MyProfileTemplate';

export function UserAbsence() {
  const {data: user, isError, isLoading} = useGetCurrentUserInfoQuery();

  return (
    <MyProfileTemplate
      header={{
        title: i18n.t('user.awayStatus.awayBadge'),
        breadcrumbs: [
          {label: i18n.t('entity.user.labels.myProfile'), isCurrentPage: true},
          {label: i18n.t('user.awayStatus.awayBadge'), isCurrentPage: true},
        ],
      }}
      isError={isError}
      isLoading={isLoading}
    >
      <Show when={user?.id ? user : null}>
        {(user) => <UserAbsenceGrid userId={user.id} data-testid="my-profile-user-absence" />}
      </Show>
    </MyProfileTemplate>
  );
}
